import {createSlice } from '@reduxjs/toolkit';

const initialState = {
    type: '',
    shouldContractsReload: false
};

export const osheeSlice = createSlice({
    name: 'oshee',
    initialState,
    reducers:
    {
        setType: (state,action) => 
        {
            state.type = action.payload
        },
        setShouldContractsReload: (state) => 
        {
            state.shouldContractsReload = !state.shouldContractsReload
        }
    }
})

export const { setType, setShouldContractsReload } = osheeSlice.actions;

export const selectOshee = (state) => state.oshee;

export default osheeSlice.reducer;

